/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon20Regular = forwardRef('DataChartPieA2Icon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001a.75.75 0 0 0-.75.75v7.25c0 .413.336.75.75.75h7.249a.75.75 0 0 0 .75-.75A7.998 7.998 0 0 0 10 2Zm.75 7.25V3.544a6.499 6.499 0 0 1 5.705 5.705H10.75Z" }),
        React.createElement("path", { d: "M7.186 4.142a.75.75 0 0 0-.65-1.352 7.999 7.999 0 1 0 10.645 10.733.75.75 0 1 0-1.347-.66 6.498 6.498 0 1 1-8.648-8.72Z" })));
});
